export const DELAY_STATUS_GET = 2000;

export const HOST_CARD_MESSAGES = [
	'Менше комісія з HOSTCARD -',
	'З HOSTCARD комісія нижче -',
	'З HOSTCARD –',
	'З HOSTCARD комісія була б',
];
